import { sizeTab } from '@/shared';
import { Box } from '@mui/material';

export type SingleBoxTableTabsOnlyProps = {
  children?: React.ReactNode;
};

const SingleBoxTableTabsOnly: React.FC<SingleBoxTableTabsOnlyProps> = ({
  children,
}) => {
  return (
    <Box
      sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 1 }}
    >
      {children}
    </Box>
  );
};

export default SingleBoxTableTabsOnly;
